// extracted by mini-css-extract-plugin
export default {"container":"add-update-dashboard_container__3EHz9","txt01":"add-update-dashboard_txt01__qV9dn"};